/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as enterpriseIdActionTypes from './EnterpriseId-ActionTypes';

const initialState = {
    enterpriseId: '',
    enterpriseIdMessage: null,
    error: '',
    loading: false,
};

const enterpriseIdReducer = (state = initialState, action) => {
    switch (action.type) {
        case enterpriseIdActionTypes.ENTERPRISE_ID_LOADING:
            return {
                ...state,
                loading: true,
            };
        case enterpriseIdActionTypes.ENTERPRISE_ID_LOADED:
            return {
                ...state,
                enterpriseId: action.data,
                loading: false,
            };
        case enterpriseIdActionTypes.ENTERPRISE_ID_MESSAGE_LOADED:
            return {
                ...state,
                enterpriseIdMessage: action.data,
            };
        case enterpriseIdActionTypes.ENTERPRISE_ID_LOADING_ERROR:
            return {
                ...state,
                error: true,
            };
        default:
            return state;
    }
};

export default enterpriseIdReducer;
